import $ from 'jquery';
import Swiper from 'swiper/swiper-bundle.min';
import { $window, MIN_DELAY, breakpoint } from '../variables/variables.js';
import { debounce } from '../functions/functions.js';
import { createSwiperToggle, } from '../functions/functions.js';



$( () => {
	if ( ! $( '.home' ).length ) {
		return;
	}

	// Начальный слайдер

	( () => {
		const $current = $( '.home__front .counter__current' );

		function setCurrent( swiper ) {
			setTimeout( () => {
				let current = +$( '.swiper-slide-active', swiper.el ).attr( 'data-swiper-slide-index' ) + 1;

				if ( current < 10 ) {
					current = '0' + current;
				}

				$current.text( current );
			}, MIN_DELAY );
		}

		const nextSlide = new Swiper( '.home__front-next .swiper', {
			effect:         'fade',
			loop:           true,
			speed:          1000,
			allowTouchMove: false,
			on: {
				click: () => {
					slider.slideNext();
				}
			},
		} );

		const slider = new Swiper( '.home__front > .swiper', {
			effect: 'fade',
			loop:   true,
			speed:  1000,
			autoplay: {
				disableOnInteraction: false,
				pauseOnMouseEnter:    true,
				delay:                3000,
			},
			navigation: {
				prevEl: '.home__front .swiper-button-next',
				nextEl: '.home__front .swiper-button-prev',
			},
			thumbs: {
				swiper: nextSlide,
			},
			on: {
				init:              setCurrent,
				resize:            setCurrent,
				activeIndexChange: setCurrent,
			},
		} );
	} )();

	// Наши проекты
	createSwiperToggle( '.home__projects', () => {
		return breakpoint.isPhone;
	} );

	// Преимущества проектов
	( () => {
		const $col1Units = $( '.home__advantages-col:first-child .home__advantages-unit' );
		const $col2Units = $( '.home__advantages-col:nth-child(3) .home__advantages-unit' );

		function setHeight() {
			$col1Units.add( $col2Units ).removeAttr( 'style' );

			if ( breakpoint.isPhone || ! breakpoint.isTablet ) {
				return;
			}

			$col1Units.each( ( i ) => {
				const $col1Unit = $col1Units.eq( i );
				const $col2Unit = $col2Units.eq( i );
				const HEIGHT    = Math.max( $col1Unit.height(), $col2Unit.height() );

				$col1Unit.add( $col2Unit ).height( HEIGHT );
			} );
		}
		setHeight();
		$window.on( 'resizeWidth', debounce( setHeight ) );
	} )();
} );
